module.exports = __webpack_public_path__ + "static/media/paperboard-side1.5e339fb5.jpg";